import React from 'react';
import './EmployeeList.css';

const TimesheetList = ({
  timesheets = [],
  onEdit,
  onApprove,
  onReject,
  onDelete,
  canEdit = false,
  canApprove = false,
  canDelete = false,
}) => {
  if (!timesheets.length) {
    return <div className="empty-state">Aucun pointage trouvé.</div>;
  }

  return (
    <div className="employee-list">
      <div className="table-container">
        <table className="employee-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Employé</th>
              <th>Absent</th>
              <th>Entrées / Sorties</th>
              <th>Pause (min)</th>
              <th>Heures</th>
              <th>Heures sup</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {timesheets.map((ts) => (
              <tr key={ts.id}>
                <td>{ts.formattedDate || ts.date}</td>
                <td>{ts.employeeName}</td>
                <td>{ts.isAbsent ? 'Oui' : '-'}</td>
                <td colSpan={1}>
                  {ts.formattedIntervals
                    || `${ts.formattedCheckInTime || ts.checkInTime || '--:--'} - ${ts.formattedCheckOutTime || ts.checkOutTime || '--:--'}`}
                </td>
                <td>{ts.breakDurationMinutes ?? 0}</td>
                <td>{ts.formattedWorkedHours || ts.workedHours || '-'}</td>
                <td>{ts.formattedOvertimeHours || ts.overtimeHours || '-'}</td>
                <td><span className={`badge ${ts.status?.toLowerCase()}`}>{ts.statusLabel || ts.status}</span></td>
                <td>
                  <div className="action-buttons">
                    {canApprove && ts.status === 'PENDING' && (
                      <>
                        <button className="btn-action" onClick={() => onApprove(ts)}>✓</button>
                        <button className="btn-action" onClick={() => onReject(ts)}>✗</button>
                      </>
                    )}
                    {canEdit && ts.status === 'PENDING' && (
                      <button className="btn-action btn-edit" onClick={() => onEdit(ts)}>✏️</button>
                    )}
                    {canDelete && (
                      <button className="btn-action btn-delete" onClick={() => onDelete(ts.id)}>🗑️</button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TimesheetList;

